import React from "react";
import { Radio, InputNumber } from "antd";

export default function TipSelector({ selection, onSelectionChange, customAmount, onCustomChange, amount }) {
  return (
    <section aria-label="Tip" style={{ margin: "20px 0" }}>
      <h3>Tip (optional)</h3>
      <Radio.Group value={selection} onChange={(event) => onSelectionChange(event.target.value)}
        style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {[0, 10, 15, 20].map((rate) => <Radio.Button key={rate} value={rate}>{rate}%</Radio.Button>)}
        <Radio.Button value="custom">Custom</Radio.Button>
      </Radio.Group>
      {selection === "custom" && (
        <InputNumber aria-label="Custom tip amount" min={0} precision={2} step={0.01}
          prefix="$" value={customAmount} onChange={onCustomChange}
          style={{ marginTop: 12, width: "100%" }} />
      )}
      <p style={{ marginTop: 20, marginBottom: 8 }}>Tip: ${amount.toFixed(2)}</p>
      <small>Percentage tips apply to items only, before delivery, taxes and fees.</small>
    </section>
  );
}
